<ion-col class="flex-align-center">
    <ion-grid>
        <ion-row>
            <ion-col size="12">
                <h2 class="page-title">Templates de Email</h2>
            </ion-col>
        </ion-row>

        <ion-row *ngFor="let item of config?.ConfigList">
            <ion-col size="12">
                <ion-card *ngFor="let tpl of templates">
                    <ion-card-header>
                        <ion-card-title>{{ tpl.label }}</ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                        <div class="detail-grid single-col">
                            <div class="detail-text">
                                <span class="detail-label">Assunto</span>
                                <span class="detail-value">{{ item?.[tpl.prefix + '_Subject'] }}</span>
                            </div>
                        </div>

                        <div class="detail-grid single-col">
                            <div class="detail-text">
                                <span class="detail-label">Corpo</span>
                                <div class="email-body" [innerHTML]="item?.[tpl.prefix + '_Body']"></div>
                            </div>
                        </div>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-col>
